import React from 'react';
import { createRoot } from 'react-dom/client';
// import { Provider } from 'react-redux';
// import { store } from './app/store';
import {
  WalletProvider,
  getChainOptions,
} from '@terra-money/wallet-provider';
import App from './App';
import { keplrWalletPlugin } from './wallets/keplr';
// import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';

// The Station/Galaxy extension answers wallet-controller's info()/connect()
// probes with a plain `{ code, message }` object when it declines, and
// LegacyExtensionConnector.recheckStates() never catches it (`refetchStates`
// calls it as a floating promise). The reason is not an Error, so the CRA dev
// overlay renders it as the useless "[object Object]". Log the real payload.
window.addEventListener('unhandledrejection', event => {
  if (event.reason instanceof Error) return;
  console.error('Unhandled rejection with a non-Error reason:', event.reason);
});

const container = document.getElementById('root');
const root = createRoot(container);

getChainOptions()
  .then(chainOptions => {
    root.render(
      <WalletProvider  {...chainOptions} plugins={[keplrWalletPlugin]}>
        <App />
      </WalletProvider>
    )
  })
  .catch(err => {
    console.error('getChainOptions() failed, cannot start the app:', err);
    container.textContent = 'Failed to load chain options. Please reload.';
  })

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
